module.exports = __webpack_public_path__ + "img/สาหร่ายสไปรูลิน่า.059133d4.jpg";